import { MIXTURE } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import options from 'utils/redux/reducingOptions/mixtures';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(MIXTURE);
const actions = { ...rawActions, ...thunkFactory(MIXTURE, '/mixture_substances/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(MIXTURE, initialState, options);

// SAGAS
const sagas = sagasFactory(MIXTURE, '/mixture_substances/', { scopedByAccount: true });
export { sagas };
